import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Card, FeatureData } from "./card.tsx";

export interface CardsProps {
    features: FeatureData[];
    onClick: (slug: string) => void;
}

export const Cards = (props: CardsProps) => {
    const { features, onClick } = props;
    return (
        <div css={cardsCss}>
            {features.map((data) => (
                <Card
                    key={data.slug}
                    data={data}
                    onClick={() => onClick(data.slug)}
                />
            ))}
        </div>
    );
};

const cardsCss = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.300")
});
